export default "__VITE_ASSET__fKUjyaC5__"